var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerateEasyLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10273_8275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10273_8275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0003 14.666C27.6028 14.666 31.3337 18.3968 31.3337 22.9993C31.3337 27.6018 27.6028 31.3327 23.0003 31.3327C18.3978 31.3327 14.667 27.6018 14.667 22.9993C14.667 18.3968 18.3978 14.666 23.0003 14.666ZM20.9362 23.8327C21.0112 25.4843 21.3012 26.9377 21.7145 28.001C21.9562 28.6227 22.2245 29.0693 22.4787 29.346C22.732 29.6218 22.9095 29.666 23.0003 29.666C23.0912 29.666 23.2687 29.6218 23.522 29.346C23.7762 29.0693 24.0445 28.6227 24.2862 28.001C24.6995 26.9377 24.9903 25.4843 25.0645 23.8327H20.9362ZM16.387 23.8327C16.5325 24.9886 16.9784 26.0862 17.6802 27.0161C18.382 27.946 19.3153 28.6758 20.387 29.1327C20.3057 28.9595 20.2304 28.7836 20.1612 28.6052C19.662 27.3218 19.342 25.6568 19.267 23.8327H16.387ZM26.7337 23.8327C26.6587 25.6568 26.3387 27.3218 25.8395 28.6052C25.7689 28.7874 25.6937 28.9632 25.6137 29.1327C26.6854 28.6758 27.6186 27.946 28.3205 27.0161C29.0223 26.0862 29.4682 24.9886 29.6137 23.8327H26.7337ZM25.6137 16.8652C25.6937 17.0352 25.7689 17.2113 25.8395 17.3935C26.3387 18.6768 26.6578 20.3418 26.7337 22.166H29.6137C29.4683 21.01 29.0225 19.9122 28.3206 18.9821C27.6188 18.052 26.6855 17.3221 25.6137 16.8652ZM23.0003 16.3327C22.9095 16.3327 22.732 16.3768 22.4787 16.6527C22.2245 16.9293 21.9562 17.376 21.7145 17.9977C21.3012 19.061 21.0112 20.5143 20.9362 22.166H25.0645C24.9895 20.5143 24.6995 19.061 24.2862 17.9977C24.0445 17.376 23.7762 16.9293 23.522 16.6527C23.2687 16.3768 23.0912 16.3327 23.0003 16.3327ZM20.3862 16.8652C19.3145 17.3223 18.3813 18.0522 17.6797 18.9823C16.978 19.9123 16.5323 21.01 16.387 22.166H19.2678C19.3428 20.3418 19.662 18.6768 20.1612 17.3935C20.2317 17.2113 20.3067 17.0352 20.3862 16.8652Z",
    fill: "#013C66"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5396,
    cy: 27.9536,
    r: 5.00635,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6169 25.9135C25.5417 25.3189 26.2489 24.9071 26.7289 25.266L31.5993 29.2963C31.9785 29.5797 31.9277 30.16 31.5021 30.4079L27.5678 32.6988C27.1421 32.9466 26.6123 32.7043 26.553 32.2347L25.6169 25.9135Z",
    fill: "#F6948B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10273_8275",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10273_8275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10273_8275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10273_8275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateEasyLink);
export default __webpack_public_path__ + "static/media/Generate Easy Link.503180317c933a6ce8482a02f1a756a5.svg";
export { ForwardRef as ReactComponent };